export const messages = {
    en: {
        message: {
            category: 'Category',
            model: 'Model',
            color: 'Color',
            unit: 'Unit',
            goBack: 'Go back',
            orSelectVehicle: 'or select your model',
            typeVIN: 'Type your VIN here...',
            categoryName: '{name}',
            Motorcycles: 'Motorcycles',
            ATV: 'ATV',
            Scooters: 'Scooters',
            'Water Scooters': 'Water Scooters',
            'Jetski': 'Jetski',
            'Mule': 'Mule',
            'Snowmobiles': 'Snowmobiles',
            'Outboard Motor': 'Outboard Motor',

            Travel: 'Travel',
            'Naked Bike': 'Naked Bike',
            'Sport Bike': 'Sport Bike',
            Supermoto: 'Supermoto',
            Mini: 'Mini',
            MX: 'MX',
            Trial: 'Trial',
            'Cross Country': 'Cross Country',
            Enduro: 'Enduro',
            Freeride: 'Freeride',
            Touring: 'Touring',

            'TR 650': 'TR 650',
            'Dual Sport': 'Dual Sport',


            selectYear: 'Select year',
            selectModel: 'Select model',
            selectProduct: 'Select product',
            product: 'Product',
            price: 'Price',
            qty: 'Qty.',
            buy: 'Buy',
            checkAvailability: 'Check availability',

            notAvailable: 'Not available',
            previous: 'Previous',
            next: 'Next',
            addingTitle: 'Adding...',
            addingDesc: 'Adding to basket...',
            checkingTitle: 'Checking...',
            checkingDesc: 'Check availability...',
            partNotFoundTitle: 'Not available!',
            partNotFoundDesc: 'Part is not available',
            foundFastDeliveryTitle: 'Found!',
            foundFastDeliveryDesc: '',
            foundSlowDeliveryTitle: 'Found!',
            foundSlowDeliveryDesc: 'Part has been found and added to your basket but delivery time may be extended',
            foundReplacementTitle: 'Superseding part found!',
            foundReplacementDesc: 'Selected part has been replaced and superseding part has been added to your basket!',
            VINNotFoundTitle: 'VIN not found',
            VINNotFoundDesc: 'Model associated with this VIN not exists',
            VINFoundTitle: 'VIN found!',
            VINFoundDesc: 'Model associated with this VIN has been found!',
            VINCheckingTitle: 'Checking...',
            VINCheckingDesc: 'We are checking VIN number...',
            VINIncorrectTitle: 'Incorrect VIN...',
            VINIncorrectDesc: 'Given VIN number is incorrect',
            allUnits: 'All',
            engine: 'Engine',
            frame: 'Frame',
            otherUnits: 'Other',

            available: 'Available',
            availableFrom: 'Available from',

        }
    },
    de: {
        message: {
            category: 'Kategorie',
            model: 'Modell',
            color: 'Farbe',
            unit: 'Baugruppe',
            goBack: 'Zurück',
            orSelectVehicle: 'oder wähle dein Modell',
            typeVIN: 'Fahrgestellnummer hier eingeben...',
            categoryName: '{name}',
            Motorcycles: 'Motorräder',
            ATV: 'ATV',
            Scooters: 'Roller',
            'Water Scooters': 'Waverunner',
            'Jetski': 'Jetski',
            'Mule': 'Mule',
            'Snowmobiles': 'Snowmobiles',
            'Outboard Motor': 'Marine',

            Travel: 'Travel',
            'Naked Bike': 'Naked Bike',
            'Sport Bike': 'Sport Bike',
            Supermoto: 'Supermoto',
            Mini: 'Mini',
            MX: 'MX',
            Trial: 'Trial',
            'Cross Country': 'Cross Country',
            Enduro: 'Enduro',
            Freeride: 'Freeride',
            Touring: 'Touring',

            'TR 650': 'TR 650',
            'Dual Sport': 'Dual Sport',

            selectYear: 'Baujahr auswählen',
            selectModel: 'Modell auswählen',
            selectProduct: 'Artikel auswählen',
            product: 'Artikel',
            price: 'Preis',
            qty: 'Menge',
            buy: 'Kaufen',
            checkAvailability: 'Verfügbarkeit prüfen',
            previous: 'Vorherige',
            next: 'Nächste',
            addingTitle: 'Informationen',
            addingDesc: 'Artikel wird in den Warenkorb gelegt. Bitte warten...',
            checkingTitle: 'Prüfe...',
            checkingDesc: 'Prüfe Verfügbarkeit...',
            partNotFoundTitle: 'Nicht verfügbar!',
            partNotFoundDesc: 'Artikel ist nicht verfügbar',
            foundFastDeliveryTitle: 'Verfügbar!',
            foundFastDeliveryDesc: 'Artikel wurde dem Warenkorb hinzugefügt!',
            foundSlowDeliveryTitle: 'Verfügbar!',
            foundSlowDeliveryDesc: 'Achtung, bei diesem Ersatzteil kann es zu Lieferverzögerungen kommen.',
            foundReplacementTitle: 'Verfügbar!',
            foundReplacementDesc: 'Dieser Artikel wurde ersetzt. Artikel wurde dem Warenkorb hinzugefügt',
            VINNotFoundTitle: 'Fahrgestellnummer nicht gefunden',
            VINNotFoundDesc: 'Wir konnten Ihre VIN keinem Fahrzeug zuordnen',
            VINFoundTitle: 'Fahrgestellnummer gefunden',
            VINFoundDesc: 'Wir konnten folgendes Fahrzeug ermitteln.',
            VINCheckingTitle: 'Überprüfe VIN...',
            VINCheckingDesc: 'Die Fahrgestellnummer wird geprüft',
            VINIncorrectTitle: 'Die VIN ist ungültig',
            VINIncorrectDesc: 'Die VIN ist ungültig',
            engine: 'Motor',
            frame: 'Rahmen',
            allUnits: 'Alle Baugruppen',
            otherUnits: 'Sonstige',

            available: 'Auf Lager',
            availableFrom: 'Verfügbar ab',
            notAvailable: 'Ausverkauft',
        }
    },
    lv: {
        message: {
            category: 'Kategorija',
            model: 'Modelis',
            color: 'Krāsa',
            unit: 'Rezerves daļu kategorija',
            goBack: 'Atpakaļ',
            orSelectVehicle: 'Vai ievadiet šasijas numuru',
            typeVIN: 'Ieraksti šasijas numuru...',
            categoryName: '{name}',
            Motorcycles: 'Motocikli',
            ATV: 'Kvadricikli',
            Scooters: 'Skūteri',
            'Water Scooters': 'Jet Ski',
            'Jetski': 'Jetski',
            'Mule': 'Mule',
            'Snowmobiles': 'Snowmobiles',
            'Outboard Motor': 'Outboard Motor',

            Travel: 'Travel',
            'Naked Bike': 'Naked Bike',
            'Sport Bike': 'Sport Bike',
            Supermoto: 'Supermoto',
            Mini: 'Mini',
            MX: 'MX',
            Trial: 'Trial',
            'Cross Country': 'Cross Country',
            Enduro: 'Enduro',
            Freeride: 'Freeride',
            Touring: 'Touring',

            'TR 650': 'TR 650',
            'Dual Sport': 'Dual Sport',


            selectYear: 'Izvēlies gadu',
            selectModel: 'Izvēlies modeli',
            selectProduct: 'Izvēlies preci',
            product: 'Prece',
            price: 'Cena',
            qty: 'Daudzums.',
            buy: 'Pirkt',
            checkAvailability: 'Check availability',
            previous: 'Iepriekšējā',
            next: 'Nākamā',
            addingTitle: 'Pievienoju...',
            addingDesc: 'Pievienoju grozam...',
            checkingTitle: 'Pārbaude...',
            checkingDesc: 'Pārbaudu pieejamību...',
            partNotFoundTitle: 'Nav pieejams!',
            partNotFoundDesc: 'Prece nav pieejama',
            foundFastDeliveryTitle: 'Atrasts!',
            foundFastDeliveryDesc: '',
            foundSlowDeliveryTitle: 'Atrasts!',
            foundSlowDeliveryDesc: 'Prece ir atrasta un pievienota pirkumu grozam. Piegādes laiks var būt ilgāks',
            foundReplacementTitle: 'Aizstājējprece ir atrasta!',
            foundReplacementDesc: 'Izvēlētā prece tika aizstāta ar aizstājējpreci un pievienota pirkumu grozam!',
            VINNotFoundTitle: 'Šasijas numurs nav atrasts',
            VINNotFoundDesc: 'Modelis ar šādu šasijas numuru neeksistē',
            VINFoundTitle: 'Šasijas numurs atrasts!',
            VINFoundDesc: 'Modelis ar šādu šasijas numuru atrasts!',
            VINCheckingTitle: 'Pārbaudu...',
            VINCheckingDesc: 'Mēs pārbaudam šasijas numuru...',
            VINIncorrectTitle: 'Nepareizs šasijas numurs...',
            VINIncorrectDesc: 'Ievadītais šasijas numurs ir nepareizs',
            allUnits: 'Viss',
            engine: 'Motors',
            frame: 'Rāmis',
            otherUnits: 'Cits',

            available: 'Pieejams',
            availableFrom: 'Available from',
            notAvailable: 'Nav pieejams',

        }
    },
}